import EquipmentFilter from './EquipmentFilter';

export default EquipmentFilter;
